import { Download } from "@carbon/icons-react";
import { FC } from "react";

import { IconButton } from "src/components/Buttons";
import { useAsync } from "src/hooks/useAsync";
import { AttachmentsApi } from "src/http/Attachments.api";
import { useT } from "src/internationalization";
import { Attachment } from "src/types/attachment";

export type DownloadAttachmentButtonProps = {
  attachment: Attachment;
};

export const DownloadAttachmentButton: FC<DownloadAttachmentButtonProps> = ({ attachment }) => {
  const t = useT();

  const [downloadFile, { loading: downloadFileLoading }] = useAsync((attachment: Attachment) =>
    AttachmentsApi.Attachments().getAttachment(attachment)
  );

  return (
    <IconButton
      kind="ghost"
      size="sm"
      label={t("page.alert.modal.attachments.button.download")}
      onClick={() => downloadFile(attachment)}
      loading={downloadFileLoading}
    >
      <Download />
    </IconButton>
  );
};
